import { render, staticRenderFns } from "./menu2_1.vue?vue&type=template&id=ad322892&scoped=true&"
import script from "./menu2_1.vue?vue&type=script&lang=js&"
export * from "./menu2_1.vue?vue&type=script&lang=js&"
import style0 from "./menu2_1.vue?vue&type=style&index=0&id=ad322892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad322892",
  null
  
)

export default component.exports